import React from 'react';
export function BenefitsSection() {
  const benefits = ['Dar clases de Lengua y Literatura con contenido claro, organizado y listo para usar', 'Tener actividades, trabajos prácticos y evaluaciones sin preparar nada adicional', 'Trabajar comprensión, escritura y literatura sin improvisar', 'Organizar TODO tu año sin perder tiempo', 'Ahorrar horas de trabajo todas las semanas'];
  return <section id="beneficios" className="py-5 sm:py-14 bg-transparent border-t border-gray-800" data-id="element-33">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-34">
        <div className="text-center mb-4 sm:mb-8" data-id="element-35">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-black text-white" data-id="element-36">
            <span className="text-[#D4A843] mr-1" data-id="element-37">✅</span> CON ESTE KIT VAS A
            PODER:
          </h2>
        </div>

        <div className="space-y-2.5 sm:space-y-4" data-id="element-38">
          {benefits.map((benefit, index) => <div key={index} className="bg-[#1a1512] border border-[#D4A843]/30 shadow-sm rounded-xl p-3 sm:p-4 flex items-start gap-3" data-id="element-39">
              <span className="text-[#D4A843] text-base sm:text-lg flex-shrink-0 mt-0.5" data-id="element-40">
                ✅
              </span>
              <p className="text-sm sm:text-base text-gray-200 font-bold leading-relaxed" data-id="element-41">
                {benefit}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}